import {post} from "../API/cloudFunctions";


export default class Token{

  constructor(){};

  static generateToken(Duid,Puid){

    if(Duid&&Puid){

      return new Promise((resolve, reject) => {
        post('generateToken',{'Duid':Duid,'Puid':Puid}).then(ss=>{
          resolve(ss);
        }).catch(err=>{
          reject(err);
        })
      })
    }
    else return null;

  }
}



// WEBPACK FOOTER //
// ./src/Class/Token.js